<template>
  <div class="alumniPublic-item">
    <!-- 头部 -->
    <div class="item-title">
      <div class="item-title__head">
        <img class="title__head-headImg" :src="dynamicData.photo ? dynamicData.photo : 'img/ic_avatar.png'" alt="" @click="detailsPage(dynamicData.userId)" :onerror="errorHeadImg">
        <img v-if="dynamicData.mpType === 3" class="title__head-badge" src="img/pub1.png" alt="">
        <img v-if="dynamicData.mpType === 4" class="title__head-badge" src="img/pub2.png" alt="">
        <img v-if="dynamicData.mpType === 5" class="title__head-badge" src="img/pub3.png" alt="">
      </div>
      <div class="item-title__name">
        <h3 @click="detailsPage(dynamicData.userId)">{{ dynamicData.nickName }}</h3>
        <!-- <span>{{ dynamicData.campusName || '未知校区'}}</span> -->
      </div>
      <div class="item-title__tag" v-if="dynamicData.lableName">
        {{ dynamicData.lableName }}
      </div>
      <div class="item-title__time">
        {{ dynamicData.createTime }}
      </div>
      <div class="shield" @click="shieldMethods">
        屏蔽
      </div>
    </div>
    <!-- 内容区 --> 
    <!-- actionType: 1动态 2评论 3回复 4点赞 5转发 6动态被屏蔽 7禁言 -->
    <div class="item-content" v-if="dynamicData.actionType === 1">
      <div class="item-content__msg">
        {{ dynamicData.content }}
      </div>
      <div class="item-content__imgs">
        <img v-for="(img, index) in  getImages(dynamicData.image)" :key="index" :src="img ? img : 'img/ic_avatar.png'" alt="" @click="bigPicture(img)" onerror="javascript:this.src='img/ic_avatar.png';">
      </div>
    </div>
    <div class="item-content-flex" v-if="dynamicData.mpQuoteMsginfo">
      <div class="flex-content__imgs">
        <img :src="dynamicData.mpQuoteMsginfo.imgUrl ? dynamicData.mpQuoteMsginfo.imgUrl : 'img/rectangle.png'" alt="" @click="bigPicture(dynamicData.mpQuoteMsginfo.imgUrl)" :onerror="errorImgRectangle">
      </div>
      <div class="flex-content__msg" @click="getQuoteMsg">
        {{dynamicData.mpQuoteMsginfo.content}}
      </div>
    </div>
    <!-- 转发-->
    <div class="item-content" v-if="dynamicData.actionType === 5">
      <div class="item-content__msg">
        {{ dynamicData.content }}
        <!-- <span v-for="(item, index) in dynamicData.transpondList" :key="index">
          \\<span>@{{ item.name }}：</span>{{ item.nr }}
        </span> -->
      </div>
      <div class="item-content__transpond">
        <div class="item-content__msg">
          <span class="item-content__trName" @click="detailsPage(dynamicData.simpleAction.userId)">{{ dynamicData.simpleAction.nickname }}：</span>
          {{ dynamicData.simpleAction.content }}
        </div>
        <div class="item-content__imgs">
          <img v-for="(img, index) in getImages( dynamicData.simpleAction.image)" :key="index" :src="img ? img : 'img/ic_avatar.png'" alt="" @click="bigPicture(img)" onerror="javascript:this.src='img/ic_avatar.png';">
        </div>
      </div>
    </div>

    <!-- 评论区 -->
    <div class="item-comment">
      <div class="location" :title="dynamicData.address">
        <i class="el-icon-location"></i>
        {{ dynamicData.address }}
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="`评论(${dynamicData.comments ? dynamicData.comments.length : 0})`" name="discuss">
          <div class="discussContent">
            <div v-if="dynamicData.comments &&  dynamicData.comments.length > 0">
              <div class="discussItem" v-for="(item, index) in dynamicData.comments" :key="index">
                <div class="showDel">
                  <span class="userNameClass" @click="detailsPage(item.commentUserId)">{{ item.commentName }}：</span>
                  {{ item.content }}
                  <i class="sp iconpingbi deleteDiscussItemIcon" @click="delDiscuss(item.id)"></i>
                </div>
                <template v-if="item.replys && item.replys.length>0">
                  <div v-for="(reply, index) in item.replys" :key="index" style="margin: 5px 0;"  class="showDel">
                    <span class="userNameClass" @click="detailsPage(reply.userId)">{{ reply.replyName }}</span>
                    <span class="huifuClass">回复</span>
                    <span class="userNameClass" @click="detailsPage(reply.userId)">{{ item.commentName }}：</span>
                    {{ reply.content }}
                    <i class="sp iconpingbi deleteDiscussItemIcon" @click="delDiscuss(reply.id)"></i>
                  </div>
                </template>
                <template v-if="item.replayList && item.replayList.length>0" >
                  <div v-for="(reply, index) in item.replayList" :key="index" style="margin: 5px 0;"  class="showDel">
                    <span class="userNameClass" @click="detailsPage(reply.commentUserId)">{{ reply.commentName }}</span>
                    <span class="huifuClass">回复</span>
                    <span class="userNameClass" @click="detailsPage(reply.replayUserId)">{{ reply.replayNickname }}：</span>
                    {{ reply.content }}
                    <i class="sp iconpingbi deleteDiscussItemIcon" @click="delDiscuss(reply.id)"></i>
                  </div>
                </template>
              </div>
            </div>
            <div v-else style="text-align: center;margin-top: 20px;">无评论...</div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="`点赞(${dynamicData.fabulous ? dynamicData.fabulous.length : 0})`" name="star">
          <div class="starContent" v-if="dynamicData.fabulous && dynamicData.fabulous.length > 0">
            <img v-for="(item, index) in dynamicData.fabulous" @click="detailsPage(item.userId)" :title="item.nickname" :key="index" :src="item.photo ? item.photo : 'img/ic_avatar.png'" onerror="javascript:this.src='img/ic_avatar.png';">
          </div>
          <div v-else style="text-align: center;margin-top: 20px; font-size: 12px;">无点赞...</div>
        </el-tab-pane>
        <el-tab-pane :label="`转发(${dynamicData.forwards ? dynamicData.forwards.length : 0})`" name="transpond">
          <div class="starContent" v-if="dynamicData.forwards && dynamicData.forwards.length > 0">
            <img  v-for="(item, index) in dynamicData.forwards" @click="detailsPage(item.userId)" :title="item.nickname" :key="index" :src="item.photo ? item.photo : 'img/ic_avatar.png'" onerror="javascript:this.src='img/ic_avatar.png';">
          </div>
          <div v-else style="text-align: center;margin-top: 20px; font-size: 12px;">无转发...</div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-divider v-if="!showLine"></el-divider>
    <el-dialog class="dialogStyle" title="查看图片" :visible.sync="ImgDialog" v-el-drag-dialog :close-on-click-modal='false'>
      <img :src="bigImg ? bigImg : 'img/rectangle.png'" alt="" :onerror="errorImgRectangle">
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="ImgDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dynamicData: Object,
    showLine: Boolean, // 是否显示分割线
  },
  data() {
    return {
      ImgDialog: false, // 图片显示弹窗
      bigImg: '',
      activeName: 'discuss',
    }
  },
  methods: {
    // 引用消息
    getQuoteMsg() {
      this.$message.error('请在手机上查看')
    },
    bigPicture(img) {
      this.bigImg = img;
      this.ImgDialog = true;
    },
    shieldMethods() {
      this.$emit('shieldMethods');
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    delDiscuss(id) {
      this.$emit('delDiscuss', id);
    },
    detailsPage(id) {
      this.$emit('detailsPage', id);
    },
    getImages(img) {
      if (img) {
        const imgArr = img.split(',');
        const images = imgArr.map(item => item.split('-')[0]);
        return images;
      }
      return []
    },
    isNull(str) {
      if (str) {
        return str.split('-');
      }
      return [];
    }
  },
}
</script>

<style lang="scss">
.alumniPublic-item {
  width: 900px;
  margin: 15px auto 0px auto;
  .item-title {
    position: relative;
    display: flex;
    align-items: center;
    &__head {
      position: relative;
      cursor: pointer;
      width: 50px;
      height: 50px;
      // overflow: hidden;
      border-radius: 50%;
      margin-right: 10px;
      .title__head-headImg {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
      .title__head-badge {
        position: absolute;
        width: 14px;
        right: 4px;
        bottom: 0;
      }
    }
    &__name {
      margin-right: 20px;
      font-size: 15px;
      h3 {
        cursor: pointer;
        margin: 0;
      }
      span {
        font-size: 12px;
        color: #999999;
      }
    }
    &__tag {
      margin-right: 15px;
      padding: 2px 8px;
      font-size: 12px;
      border-radius: 2px;
      color: #999999;
      background-color: #F2F2F2;
    }
    &__time {
      font-size: 12px;
      color: #666666
    }
    .shield {
      position: absolute;
      right: 0;
      top: 12px;
      color: #545454;
      font-size: 14px;
      border: 1px solid #DCDEE2;
      padding: 2px 13px;
      border-radius: 15px;
      cursor: pointer;
    }
    .shield:hover {
      color:#2D8CF0;
      border: 1px solid #2D8CF0;
    }
  }
  .item-content {
    margin-top: 10px;
    padding-left: 60px;
    &__msg {
      color: #606266;
      font-size: 14px;
      overflow: hidden;
      max-height: 150px;
    }
    &__imgs {
      margin-top: 10px;
      img {
        cursor: pointer;
        margin-right: 10px;
        width: 80px;
        height: 80px;
        border-radius: 5px;
      }
    }
    &__trName {
      cursor: pointer;
      font-weight: bolder;
      color: #3c3c3c;
    }
    &__transpond {
      margin-top: 10px;
      background-color: #F2F2F2;
      padding: 10px 15px;
      border-radius: 5px;
    }
  }
  .item-content-flex {
    border-radius: 0 4px 4px 0;
    font-size: 0;
    margin-top: 10px;
    margin-left: 60px;
    background-color:#f7f8fa;
    display: flex;
    align-items: center;
    .flex-content__imgs {
      img {
        width: 88px;
        height: 56px;
        cursor: pointer;
      }
    }
    .flex-content__msg {
      cursor: pointer;
      word-break: break-all;
      padding-left: 4px;
      color: #606266;
      font-size: 14px;
    }
  }
  .item-comment {
    position: relative;
    margin-top: 10px;
    padding-left: 60px;
    .location {
      z-index: 999;
      width: calc(100% - 294px);
      text-align: right;
      position: absolute;
      right: 0;
      top: 15px;
      font-size: 12px;
      color: #999999;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .el-tabs__content {
      min-height: 44px;
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
    .el-tabs__header {
      margin: 0 0 5px;
    }
    .discussContent {
      font-size: 13px;
      .discussItem {
        margin: 5px 0;
        .userNameClass {
          color: #38adff;
          cursor: pointer;
        }
        .huifuClass {
          margin: 0 5px;
        }
        .deleteDiscussItemIcon {
          margin-left: 8px;
          cursor: pointer;
          font-size: 13px;
          opacity:0;
        }
      }
      .showDel:hover .deleteDiscussItemIcon {
        opacity: 1;
      }
    }
    .starContent {
      img {
        cursor: pointer;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin: 5px 10px 5px 0;
      }
    }
  }
  .dialogStyle {
    .el-dialog__body {
      text-align: center;
      padding: 0!important;
    }
    img {
      // background-color: rgba(0, 0, 0, .2);
      max-width: 100%;
      max-height: 600px;
    }
  }
}
</style>
